import React from 'react';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useAuth0 } from "@auth0/auth0-react";
import LoginAlert from "../components/Login/LoginAlert";

import useGlobalStyles from '../css/GlobalStyles';

export default function CaseLogin() {
    const { user, isAuthenticated, isLoading } = useAuth0();

    const classes = useGlobalStyles();

    //loading logic
    if (isLoading) {
        return (
            <div>
                <br /> &nbsp;Carregando dados ...
            </div>
        );
    }
    return (
        <React.Fragment>
            <Grid
                container
                className={classes.root}
                alignItems="center"
                spacing={0}
            >
                <Card className={classes.cardLogin}>
                    <Paper className={classes.paper} elevation={5}>
                        {isAuthenticated ? (
                            <div>
                                <Typography component="h4" variant="h4" align="center" style={{ marginBottom: 50 }}>
                                    Welcome to Lifty Admin Dashboard
                                </Typography>
                                <Typography component="h4" variant="h4" align="center" style={{ marginBottom: 50 }}>
                                    {user.email}
                                </Typography>
                            </div>
                        ) : (<LoginAlert />)}
                    </Paper>
                </Card>
            </Grid>
        </React.Fragment >
    )
}